/**
 * Helper type to extract the value of an object type
 * ie: ValueOf<typeof FlowActionTrackingEvents>
 * Replaces having to do `typeof FlowActionTrackingEvents[keyof typeof FlowActionTrackingEvents]`
 */
export type ValueOf<T> = T[keyof T];

/**
 * Helper type to extract keys from an object type
 * ie: nameof<FormValues>('dateTime')
 */
export const nameof = <T>(name: keyof T): keyof T => name;

/**
 * Helper function to extract the name of a property from an object type
 * ie: const nameOfPage = nameofFactory<PopupPage>()
 * name: nameOfPage('headline')
 */
export const nameofFactory =
  <T>() =>
  (name: keyof T): keyof T =>
    name;
